import type { FontWeight } from "@homeinstead/schemas";
import type { ButtonVariantProps } from "@homeinstead/ui/components/Button";
import type {
  ButtonColorVariant,
  ButtonWidthVariant,
} from "~www/types/button-style";

const COLOR_VARIANT_MAP: Record<
  ButtonColorVariant,
  ButtonVariantProps["variant"]
> = {
  friendly: "friendly",
  "new-beginnings": "primary",
  outline: "outline",
};

const FONT_WEIGHT_CLASS: Record<FontWeight, string> = {
  bold: "font-bold",
  regular: "font-normal",
  semibold: "font-semibold",
};

const WIDTH_VARIANT_CLASS: Record<ButtonWidthVariant, string> = {
  auto: "w-auto",
  full: "w-full",
  responsive: "w-full md:w-auto",
  "responsive-min-w": "w-full md:w-auto md:min-w-[296px]",
};

export { COLOR_VARIANT_MAP, FONT_WEIGHT_CLASS, WIDTH_VARIANT_CLASS };
